<template>
  <div>
    <v-tooltip color="fin-color-accent-red" right :disabled="!icon">
      <template #activator="{ on }">
        <v-btn :icon="icon"
               :loading="loading"
               :outlined="!icon"
               class="sign-out"
               color="white"
               tile
               v-on="on"
               @click.prevent="submit">
          <v-icon color="#73769a" v-if="icon">icon-logout</v-icon>
          <span v-else>Abmelden</span>
        </v-btn>
      </template>
      <span>Abmelden</span>
    </v-tooltip>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import finBrowser from "@/js/finBrowser"

export default {
  name: 'fin-sign-out-btn',
  props: {
    icon: {
      type: Boolean
    }
  },
  data() {
    return {
      loading: false,
      error: ''
    }
  },
  methods: {
    ...mapActions('auth', ['signOut']),
    async submit() {
      this.loading = true
      await this.signOut()
      let query = {}
      if (finBrowser.IS_IOS_OR_ANDROID_APP) {
        query = {
          userHasLoggedOut: true
        }
      }
      this.$router.push({path: '/', query: query}).catch((e) => console.error("Failed to route after sign out", e))
      this.loading = false
    },
  }
}
</script>

<style scoped>

</style>
